import { render, staticRenderFns } from "./pigaiList.vue?vue&type=template&id=3bc40bea&scoped=true"
import script from "./pigaiList.vue?vue&type=script&lang=js"
export * from "./pigaiList.vue?vue&type=script&lang=js"
import style0 from "./pigaiList.vue?vue&type=style&index=0&id=3bc40bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc40bea",
  null
  
)

export default component.exports